
const PrivacyPolicy = () => {
    return <h1>Política de Privacidade</h1>;
};

export default PrivacyPolicy;